export default __webpack_public_path__ + "assets/numbrz-logo-116.png";